import classNames from 'classnames';
import React from 'react';
import IconTarget from '../ui/icons/IconTarget';

const WhatHappensNext = props => {
  const steps = [
    {
      id: '{ 01 }',
      title: 'Form Submission',
      content: 'Once you submit your details, we receive your inquiry immediately',
      active: true,
    },
    { id: '{ 02 }', title: 'Initial Review', content: 'Our team reviews your information to understand your needs and goals.', active: false },
    {
      id: '{ 03 }',
      title: 'Contact',
      content: 'Within 24 hours, one of our account managers will reach out to you via email or phone to discuss further details.',
      active: false,
    },
    {
      id: '{ 04 }',
      title: 'Proposal',
      content: "After our discussion, we'll craft a customized proposal tailored to your goals and budget.",
      active: false,
    },
    {
      id: '{ 05 }',
      title: 'Agreement',
      content: 'If you decide to proceed, we’ll finalize the terms and kick off your project.',
      active: false,
    },
  ];

  return (
    <ul className="relavtive">
      {steps.map(({ id, active, title, content }, index) => {
        return (
          <li key={index} className="relative h-full">
            <div className={`absolute left-[-25px]  w-[2px]  h-full  bg-[#4DA454]`}>
              <div className={`absolute ${index === 0 ? 'left-[-5px]' : 'left-[-12px]'} `}>
                {index === 0 ? <div className="blobGreen w-full"></div> : <IconTarget color="#C4C4C4" />}
              </div>
            </div>
            <h2 className={classNames('flex items-center md:gap-[18px] gap-[8px] text-[18px] font-[400] leading-[21px]')}>
              <span className={classNames(active ? 'text-[#4DA454]' : 'text-[#C4C4C4]', 'min-w-[15px]')}>{id}</span>
              <span className={classNames(active ? 'text-[#F7931A]' : 'text-[#C4C4C4]', 'uppercase')}>{title}</span>
            </h2>

            <p
              className={`md:ml-[60px] ml-[50px] mt-[10px] ${index !== 4 && 'pb-[54px]'} text-[16px] font-[400] leading-[20px] ${!active && 'text-[#C4C4C4]'}`}
            >
              {content}
            </p>
          </li>
        );
      })}
    </ul>
  );
};

export default WhatHappensNext;
